import {Easing, TextProps, ViewStyle} from 'react-native';
import SkillzStyle from 'SkillzStyle';

const {fullStyles} = SkillzStyle;

export const BUBBLE_TEXT_STYLE = {
  color: '#333333',
  fontSize: 15,
  lineHeight: 18,
  letterSpacing: -0.5,
  fontFamily: (fullStyles.fontExtraBold || fullStyles.fontBold).fontFamily,
};

export const BUBBLE_TEXT_PROPS: TextProps = {
  allowFontScaling: false,
  numberOfLines: 3,
};

export const BUBBLE_TEXT_CONTAINER_STYLE: ViewStyle = {
  paddingBottom: 0,
  paddingHorizontal: 14,
  alignItems: 'center',
};

export const BUBBLE_ANIMATION = {
  toValue: 1,
  duration: 700,
  easing: Easing.out(Easing.quad),
  useNativeDriver: true,
};
